import { BaseDto } from "./base.dto";
import { EmployeeDto } from "./employee.dto";

export class EmployeeCheckInDto extends BaseDto {
    employeeId: number;
    checkDate: Date;
    employee: EmployeeDto;
    merchantId?: number;
}